var _a, _b;
import TaskTypes from 'src/enums/TaskTypes';
import TaskCategories from 'src/enums/TaskCategories';
export var trackStatusToIntlMap = {
    canceled: 'canceled',
    completed: 'completed',
    inProgress: 'inProgress',
    notStarted: 'notStarted',
    overdue: 'overdue',
    planned: 'planned',
};
// TODO: Need to select better shade of these colors
export var trackStatusToColorMap = {
    canceled: '#800020',
    completed: 'green',
    inProgress: 'blue',
    notStarted: '#b48648',
    overdue: 'red',
    planned: 'pink',
};
export var taskTypeToIntlMap = (_a = {},
    _a[TaskTypes.WATCH_VIDEO] = 'watch-video',
    _a[TaskTypes.OPERATIONAL] = 'operation',
    _a[TaskTypes.GOVERNANCE] = 'governance',
    _a);
export var taskCategoryToIntlMap = (_b = {},
    _b[TaskCategories.MANDATORY] = 'mandatory',
    _b[TaskCategories.RECOMMENDED] = 'recommended',
    _b);



//////////////////
// WEBPACK FOOTER
// ./src/maps/tasks.ts
// module id = 798
// module chunks = 81